{
  "info": "Информация",
  "negative": "Грешка",
  "positive": "Успешно"
}
